import translations from './lang';
import getLanguageFromStorage from '../helpers/getLanguageFromStorage';
/**
 * This finds a string from <language>.json, then replaces its slots with values, returning a fully formatted string for the UI.
 * @param {Object} lang Object that has key of the string from <language>.json
 * @param {Object} data Values of slots to replace.  Key is slot, value is replacement.
 */
export default (function (lang, data) {
    var language = getLanguageFromStorage();
    var strings = translations[language];
    var messageKey = Object.keys(lang)[0];
    var message = strings[messageKey][lang[messageKey]];
    var result;
    if (data) {
        if (typeof message === 'string') {
            result = message;
            var args = Object.keys(data);
            args.forEach(function (arg) {
                result = result.replace("%".concat(arg, "%"), data[arg]);
            });
        }
        else {
            result = message(data);
        }
    }
    return result || message;
});
